module.exports = __webpack_public_path__ + "static/media/suits_grid.3a8e813b.png";